import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

const RegistrationPageThreeComp = () => {

    const size = useWindowSize();

    function useWindowSize() {
        // Initialize state with undefined width/height so server and client renders match
        // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
        const [windowSize, setWindowSize] = useState({
            width: undefined,
            height: undefined,
        });
        useEffect(() => {
            // Handler to call on window resize
            function handleResize() {
                // Set window width/height to state
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            }
            // Add event listener
            window.addEventListener("resize", handleResize);
            // Call handler right away so state gets updated with initial window size
            handleResize();
            // Remove event listener on cleanup
            return () => window.removeEventListener("resize", handleResize);
        }, []); // Empty array ensures that effect is only run on mount
        return windowSize;
    }

    const dispatch = useDispatch()
    const dataInputRegistration = useSelector(state => state.dataInputRegistration)

    // console.log(dataInputRegistration)

    const handleChangeFormInput = (key, e) => {
        dispatch({ type: key, 'value': e });
    }

    return (
        <>
            <div className='col-lg-12' style={{ marginBottom: '2%' }}>
                {
                    size.width < 500 ?
                        <h5>Syarat dan Ketentuan</h5>
                        :
                        <h3 style={{ fontSize: '20px', fontWeight: '600' }}>Syarat dan Ketentuan</h3>
                }
                <hr style={{ marginBottom: '2%', marginTop: '2%' }}></hr>
                <div className='row mb-3'>
                    {
                        size.width < 500 ?
                            <h5 style={{ color: '#0C86D9', marginBottom: '2%' }}>Metode Pembayaran melalui Corporate</h5>
                            :
                            <h3 style={{ color: '#0C86D9', marginBottom: '2%', fontSize: '16px', fontWeight: '700' }}>Metode Pembayaran melalui Corporate</h3>
                    }
                    <tr className='mb-3'>
                        <th style={{ fontWeight: '400', fontSize: size.width < 500 ? '12px' : '16px' }}>1.&nbsp;</th>
                        <th style={{ fontWeight: '400', fontSize: size.width < 500 ? '12px' : '16px' }}>Pembayaran dilakukan atas nama perusahaan</th>
                    </tr>
                    <tr className='mb-3'>
                        <th style={{ fontWeight: '400', fontSize: size.width < 500 ? '12px' : '16px' }}>2.&nbsp;</th>
                        <th style={{ fontWeight: '400', fontSize: size.width < 500 ? '12px' : '16px' }}>Invoice dan Faktur Pajak atas nama perusahaan</th>
                    </tr>
                    <tr className='mb-3'>
                        <th style={{ fontWeight: '400', fontSize: size.width < 500 ? '12px' : '16px' }}>3.&nbsp;</th>
                        <th style={{ fontWeight: '400', fontSize: size.width < 500 ? '12px' : '16px' }}>Invoice dan Faktur Pajak <b>tidak bisa direvisi</b></th>
                    </tr>
                    <tr className='mb-3'>
                        <th style={{ fontWeight: '400', fontSize: size.width < 500 ? '12px' : '16px' }}>4.&nbsp;</th>
                        <th style={{ fontWeight: '400', fontSize: size.width < 500 ? '12px' : '16px' }}>Metode pembayaran <b>tidak bisa diubah</b></th>
                    </tr>
                </div>
                <div className='row mb-3'>
                    {
                        size.width < 500 ?
                            <h5 style={{ color: '#0C86D9', marginBottom: '2%' }}>Metode Pembayaran melalui Individu</h5>
                            :
                            <h3 style={{ color: '#0C86D9', marginBottom: '2%', fontSize: '16px', fontWeight: '700' }}>Metode Pembayaran melalui Individu</h3>
                    }
                    <tr className='mb-3'>
                        <th style={{ fontWeight: '400', fontSize: size.width < 500 ? '12px' : '16px' }}>1.&nbsp;</th>
                        <th style={{ fontWeight: '400', fontSize: size.width < 500 ? '12px' : '16px' }}>Pembayaran dilakukan atas nama Individu</th>
                    </tr>
                    <tr className='mb-3'>
                        <th style={{ fontWeight: '400', fontSize: size.width < 500 ? '12px' : '16px' }}>2.&nbsp;</th>
                        <th style={{ fontWeight: '400', fontSize: size.width < 500 ? '12px' : '16px' }}>Invoice dan Faktur Pajak atas nama Individu</th>
                    </tr>
                    <tr className='mb-3'>
                        <th style={{ fontWeight: '400', fontSize: size.width < 500 ? '12px' : '16px' }}>3.&nbsp;</th>
                        <th style={{ fontWeight: '400', fontSize: size.width < 500 ? '12px' : '16px' }}>Jika ada proses reimburse di Corporate Anda, diharapkan mendaftar atas nama corporate meskipun transaksi yang Anda lakukan untuk Anda/Individu sendiri. Hal ini dilakukan agar Invoice dan Faktur Pajak bisa atas nama perusahaan Anda</th>
                    </tr>
                    <tr className='mb-3'>
                        <th style={{ fontWeight: '400', fontSize: size.width < 500 ? '12px' : '16px' }}>4.&nbsp;</th>
                        <th style={{ fontWeight: '400', fontSize: size.width < 500 ? '12px' : '16px' }}>Pembayaran menggunakan <b>Transfer Verifikasi Cepat</b>, mohon menyimpan kode unik Anda dan tidak perlu melampirkan/mengupload bukti transfer</th>
                    </tr>
                    <tr className='mb-3'>
                        <th style={{ fontWeight: '400', fontSize: size.width < 500 ? '12px' : '16px' }}>5.&nbsp;</th>
                        <th style={{ fontWeight: '400', fontSize: size.width < 500 ? '12px' : '16px' }}>Pembayaran menggunakan <b>Transfer Bank</b>, mohon menyimpan bukti transfer dan di upload di bagian dashboard Riwayat Transaksi di website</th>
                    </tr>
                    <tr className='mb-3'>
                        <th style={{ fontWeight: '400', fontSize: size.width < 500 ? '12px' : '16px' }}>6.&nbsp;</th>
                        <th style={{ fontWeight: '400', fontSize: size.width < 500 ? '12px' : '16px' }}>Invoice dan Faktur Pajak <b>tidak bisa direvisi</b></th>
                    </tr>
                    <tr className='mb-3'>
                        <th style={{ fontWeight: '400', fontSize: size.width < 500 ? '12px' : '16px' }}>7.&nbsp;</th>
                        <th style={{ fontWeight: '400', fontSize: size.width < 500 ? '12px' : '16px' }}>Metode pembayaran <b>tidak bisa diubah</b></th>
                    </tr>
                </div>
                <div className='row mt-3'>
                    <tr>
                        <th>
                            <input className="form-check-input" type="checkbox" style={{ width: '20px', height: '20px', backgroundColor: dataInputRegistration.syaratKetentuan === false ? '#FFFFFF' : '' }} onClick={(e) => handleChangeFormInput('SET_SYARAT_KETENTUAN', dataInputRegistration.syaratKetentuan === true ? false : true)} checked={dataInputRegistration.syaratKetentuan} />
                        </th>
                        <th style={{ fontWeight: '400', fontSize: size.width < 500 ? '12px' : '16px' }}>&nbsp;<b type='button' onClick={(e) => handleChangeFormInput('SET_SYARAT_KETENTUAN', dataInputRegistration.syaratKetentuan === true ? false : true)}>Dengan ini saya telah membaca dan menyetujui Syarat dan Ketentuan untuk mengikuti program yang saya daftarkan.</b></th>
                    </tr>
                </div>
            </div>
        </>
    )
}

export default RegistrationPageThreeComp
